/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiACLRoleFromJSON, ApiACLRoleToJSON, } from './ApiACLRole';
import { ApiAuthProjectFromJSON, ApiAuthProjectToJSON, } from './ApiAuthProject';
import { ApiAuthSimpleClientFromJSON, ApiAuthSimpleClientToJSON, } from './ApiAuthSimpleClient';
export function ApiAuthPermissionFromJSON(json) {
    return ApiAuthPermissionFromJSONTyped(json, false);
}
export function ApiAuthPermissionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'client': !exists(json, 'client') ? undefined : ApiAuthSimpleClientFromJSON(json['client']),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'environment': !exists(json, 'environment') ? undefined : json['environment'],
        'project': !exists(json, 'project') ? undefined : ApiAuthProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'role': !exists(json, 'role') ? undefined : ApiACLRoleFromJSON(json['role']),
    };
}
export function ApiAuthPermissionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'client': ApiAuthSimpleClientToJSON(value.client),
        'clientId': value.clientId,
        'environment': value.environment,
        'project': ApiAuthProjectToJSON(value.project),
        'projectId': value.projectId,
        'role': ApiACLRoleToJSON(value.role),
    };
}
